import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a68e93ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a68e93ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68e93ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a68e93ca')) {
      api.createRecord('a68e93ca', component.options)
    } else {
      api.reload('a68e93ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a68e93ca&scoped=true", function () {
      api.rerender('a68e93ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/riskControl/components/RiskControlDialog/index.vue"
export default component.exports